export enum PlayerTournamentScoresQueryKey {
  Primary = '/player-tournament-scores',
  Me = '/player-tournament-scores/me',
}
